import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import get from 'tcweb-material-components/core/poly/get'
import isString from 'lodash/isString'

import Link from '../../common/link'

const translateStrings = (element, t) =>
	React.Children.map(element, (child) => {
		if (isString(child)) return t(child)

		if (!get(child, 'props.children')) return child

		return React.cloneElement(child, {
			...child.props,
			children: translateStrings(child.props.children, t)
		})
	})

const MobileMenuItem = forwardRef(({ children, ...rest }, ref) => {
	const { t } = useTranslation()

	return (
		<Link {...rest} ref={ref}>{translateStrings(children, t)}</Link>
	)
})

export default MobileMenuItem
